var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c(
        "v-card-actions",
        [
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { flat: "", small: "", color: "primary" },
              on: {
                click: function($event) {
                  return _vm.$emit("edit", _vm.node)
                }
              }
            },
            [_c("v-icon", [_vm._v("edit")]), _vm._v(" edit")],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { flat: "", small: "", color: "primary" },
              on: {
                click: function($event) {
                  return _vm.$emit("delete", _vm.node)
                }
              }
            },
            [_c("v-icon", [_vm._v("delete")]), _vm._v(" delete")],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-card-title", [
        _c("h2", [
          _vm._v(
            "\n      " +
              _vm._s(_vm.schema.title) +
              ' "' +
              _vm._s(_vm.node.label) +
              '"\n      '
          ),
          _c("span", { staticClass: "node-id" }, [
            _vm._v("#" + _vm._s(_vm.node.id))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("v-card-text", [
        _c("table", { staticClass: "display-node" }, [
          _c(
            "tbody",
            [
              _vm._l(_vm.schema.properties, function(field, key) {
                return [
                  field.type == "object"
                    ? _vm._l(field.properties, function(
                        subField,
                        subKey,
                        index
                      ) {
                        return _c("tr", [
                          index == 0
                            ? _c(
                                "th",
                                {
                                  attrs: {
                                    rowspan: Object.keys(field.properties)
                                      .length
                                  }
                                },
                                [_vm._v(_vm._s(field.title))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("th", [_vm._v(_vm._s(subField.title))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(_vm.node.data[key][subKey]))])
                        ])
                      })
                    : _c("tr", [
                        _c("th", { attrs: { colspan: "2" } }, [
                          _vm._v(_vm._s(field.title))
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(_vm.node.data[key]))])
                      ])
                ]
              })
            ],
            2
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24189438", { render: render, staticRenderFns: staticRenderFns })
  }
}